// ✅ Enhanced Reusable Footer Component with Tailwind + Bharat theme
// Includes: Donate CTA, Privacy, Contact, Social links, Disclaimer

import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-gradient-to-r from-orange-400 via-white to-green-500 text-gray-800 py-10 border-t border-gray-300">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
          {/* About Section */}
          <div>
            <h3 className="text-lg font-bold mb-2 text-green-800">About JanShakti</h3>
            <p className="text-sm">
              JanShakti is a citizen-powered platform for raising local issues, promoting democratic accountability, and building a stronger Bharat — beyond caste or religion.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-2 text-green-800">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/issues" className="hover:underline">✊ Raise an Issue</Link></li>
              <li><Link to="/dashboard" className="hover:underline">📊 Voter Dashboard</Link></li>
              <li><Link to="/privacy" className="hover:underline">🔐 Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:underline">📜 Terms & Conditions</Link></li>
              <li><Link to="/donate" className="hover:underline">💸 Donate</Link></li>
            </ul>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="text-lg font-bold mb-2 text-green-800">Contact</h3>
            <p className="text-sm">📧 Email: <a href="mailto:info@janshakti.in" className="text-blue-700 hover:underline">info@janshakti.in</a></p>
            <p className="text-sm mt-2">📍 Made in Bihar, India 🇮🇳</p>
            <div className="mt-4 flex justify-center md:justify-start gap-3">
              <button className="hover:text-blue-700">Facebook</button>
              <button className="hover:text-blue-700">Twitter</button>
              <button className="hover:text-blue-700">Instagram</button>
            </div>
          </div>
        </div>

        <div className="text-center text-xs text-gray-600 mt-10 border-t pt-4">
          <p className="italic">This platform is built with love and purpose to uplift Indian democracy by Navin Kumar (AIML, Bihar).</p>
          <p className="mt-2">© {new Date().getFullYear()} <span className="font-semibold text-green-700">JanShakti</span>. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
